// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"328":"admin","378":"user"}[chunkId] || chunkId) + "." + {"328":"d3b17012","378":"eff17a19","423":"5f00c26f"}[chunkId] + ".js";
};